import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdmissionsRoutingModule } from './admissions-routing.module';
import { AdmissionsComponent } from './admissions/admissions.component';
import { CampusVirtualTourComponent } from './campus-virtual-tour/campus-virtual-tour.component';
import { AdmissionCriteriaComponent } from './admission-criteria/admission-criteria.component';
import { AdmissionFlowComponent } from './admission-flow/admission-flow.component';
import { ProgramFeeComponent } from './program-fee/program-fee.component';
import { HostelFeeComponent } from './hostel-fee/hostel-fee.component';
import { TransportationFeeComponent } from './transportation-fee/transportation-fee.component';
import { ScholarshipComponent } from './scholarship/scholarship.component';
import { InnovativeIdeaScholarshipComponent } from './innovative-idea-scholarship/innovative-idea-scholarship.component';
import { FeeStructureForPreviousYearStudentsComponent } from './fee-structure-for-previous-year-students/fee-structure-for-previous-year-students.component';
import { EducationLoanAssistanceComponent } from './education-loan-assistance/education-loan-assistance.component';
import { HowToApplyComponent } from './how-to-apply/how-to-apply.component';
import { PaymentProcedureComponent } from './payment-procedure/payment-procedure.component';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';
import { AvenuesForSuccessAarniComponent } from './avenues-for-success-aarni/avenues-for-success-aarni.component';
import { LateralEntryMigrationComponent } from './lateral-entry-migration/lateral-entry-migration.component';
import { FaqsComponent } from './faqs/faqs.component';
import {ReactiveFormsModule} from "@angular/forms";

@NgModule({
  declarations: [
    AdmissionsComponent,
    CampusVirtualTourComponent,
    AdmissionCriteriaComponent,
    AdmissionFlowComponent,
    ProgramFeeComponent,
    HostelFeeComponent,
    TransportationFeeComponent,
    ScholarshipComponent,
    InnovativeIdeaScholarshipComponent,
    FeeStructureForPreviousYearStudentsComponent,
    EducationLoanAssistanceComponent,
    HowToApplyComponent,
    PaymentProcedureComponent,
    RefundPolicyComponent,
    AvenuesForSuccessAarniComponent,
    LateralEntryMigrationComponent,
    FaqsComponent,
  ],
    imports: [
        CommonModule,
        AdmissionsRoutingModule,
        ReactiveFormsModule
    ]
})
export class AdmissionsModule { }
